import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';

import { FullscreenModalRef } from '../fullscreen-modal-ref';
import { FULLSCREEN_DIALOG_DATA } from '../fullscreen-modal-tokens';

@Component({
  selector: 'app-full-screen-modal-content',
  templateUrl: './full-screen-modal-content.component.html',
  styleUrls: ['./full-screen-modal-content.component.scss']
})
export class FullScreenModalContentComponent implements OnInit, AfterViewInit {
  @ViewChild('modalEl') modalElRef: ElementRef = {} as ElementRef;
  constructor(
    public fullscreenModalRef: FullscreenModalRef,
    @Inject(FULLSCREEN_DIALOG_DATA) public data: any) { }


  @Input() loading$: Observable<boolean> = of(true);
  @Input() headerTilte: Observable<boolean> = of(false);
  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.setFocusFirstFocusableElement();
  }

  private setFocusFirstFocusableElement() {
    const els = this.modalElRef.nativeElement.querySelectorAll('button');
    els[0].focus();
  }

  close() {
    this.fullscreenModalRef.close();
  }

}
